import {Button, COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

export const CTA: FC<{
  url: string;
  label: string;
  isHighTierCTA?: boolean;
  addArrowIcon?: boolean;
  darkMode?: boolean;
}> = ({url, label, isHighTierCTA, addArrowIcon, darkMode}) => {
  return (
    <StyledButton
      data-testid="cta"
      href={url}
      variant={isHighTierCTA || !darkMode ? 'secondary' : 'primary'}
      $isHighTierCTA={isHighTierCTA}
      data-dark-mode={darkMode}
      aria-label={undefined}
      size="lg"
    >
      {label}
      {addArrowIcon && (
        <Icon
          asset={GenericIconName.RightArrowSharpEdges}
          size="XS"
          fill={isHighTierCTA || !darkMode ? COLORS.Black : COLORS.White}
        />
      )}
    </StyledButton>
  );
};

const StyledButton = styled(Button)<{
  $isHighTierCTA?: boolean;
}>`
  &&& {
    margin-inline: auto;

    ${({$isHighTierCTA}) =>
      $isHighTierCTA
        ? css`
            margin-top: 8px;
            margin-bottom: 48px;
          `
        : css`
            margin-top: 16px;
            border: 1px solid ${COLORS.Grey3};
          `}
  }

  & > span {
    padding-block: 14px;
    line-height: 1.4285714286;
  }
`;
